// Counts the numbers of a [data-count-up] element up from zero when it scrolls
// into view. Every number in the text runs, so ranges like „90–220” animate
// both ends and the separators and units stay as the editor typed them.
document.addEventListener('DOMContentLoaded', () => {
    const counters = document.querySelectorAll('[data-count-up]');
    if (!counters.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const duration = 1600;
    const numberPattern = /\d+(?:[.,]\d+)?/g;

    function parse(text) {
        return (text.match(numberPattern) || []).map((raw) => {
            const separator = raw.includes(',') ? ',' : '.';
            const decimals = raw.includes(separator) ? raw.split(separator)[1].length : 0;
            return { value: parseFloat(raw.replace(',', '.')), separator, decimals };
        });
    }

    function render(template, numbers, progress) {
        let index = 0;
        return template.replace(numberPattern, () => {
            const { value, separator, decimals } = numbers[index++];
            return (value * progress).toFixed(decimals).replace('.', separator);
        });
    }

    function run(counter) {
        const { template, numbers } = counter;
        const start = performance.now();

        function frame(now) {
            const t = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            counter.el.textContent = t < 1 ? render(template, numbers, eased) : template;
            if (t < 1) window.requestAnimationFrame(frame);
        }

        window.requestAnimationFrame(frame);
    }

    const prepared = new Map();

    counters.forEach((el) => {
        const template = el.textContent.trim();
        const numbers = parse(template);
        if (!numbers.length) return;

        // The final width is reserved up front, so the unit next to the number
        // does not shift while the digits grow.
        el.style.minWidth = `${el.getBoundingClientRect().width}px`;
        el.textContent = render(template, numbers, 0);
        prepared.set(el, { el, template, numbers });
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            run(prepared.get(entry.target));
        });
    }, { threshold: 0.6 });

    prepared.forEach((counter, el) => observer.observe(el));
});
